var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:bxs-lock-alt",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3388 15.3225C25.3388 13.9716 24.2402 12.873 22.8893 12.873H21.6645V9.19873C21.6645 5.82208 18.9174 3.07495 15.5407 3.07495C12.1641 3.07495 9.41694 5.82208 9.41694 9.19873V12.873H8.19219C6.84128 12.873 5.74268 13.9716 5.74268 15.3225V25.1206C5.74268 26.4715 6.84128 27.5701 8.19219 27.5701H22.8893C24.2402 27.5701 25.3388 26.4715 25.3388 25.1206V15.3225ZM11.8665 9.19873C11.8665 7.17298 13.515 5.52446 15.5407 5.52446C17.5665 5.52446 19.215 7.17298 19.215 9.19873V12.873H11.8665V9.19873Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cc0958e51c080b231d8da8d71881b60f.svg";
export { ForwardRef as ReactComponent };